import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import DropArea from './DropArea.js';
import { FileList } from './FileList.js';
const FileUpload = (props) => {
    const { disabled, isUploading, success, error, refDiv, refLink, mainText, mainSubText, secondaryText, children, hidingDropArea = true, } = props;
    const dropAreaVisible = !hidingDropArea || (!isUploading && !success && !error);
    return (_jsxs(_Fragment, { children: [dropAreaVisible && (_jsx(DropArea, { disabled: disabled, refDiv: refDiv, refLink: refLink, mainText: mainText, mainSubText: mainSubText, secondaryText: secondaryText, children: children })), _jsx(FileList, { ...props })] }));
};
export default FileUpload;
